export const environment = {
  production: false,
  apiUrl: 'https://pegasusdashboard-stage.crane.aero/api/v1',
};
